import {DPLayerMapping, MappingProps} from '../dynamicParameters.types';
import {SourceLayerParam} from '../dynamicParameters.enums';
import {layerByType} from '../dynamicParameters.consts';
import _fromPairs from 'lodash/fromPairs';

const mappingPropsBySourceLayerParam: Record<SourceLayerParam, keyof MappingProps | '---'> = {
  [SourceLayerParam.TextSource]: 'txtData',
  [SourceLayerParam.FillColor]: 'fillColor',
  [SourceLayerParam.StrokeColor]: 'strokeColor',
  [SourceLayerParam.ColorOverlay]: 'colorOverlay',
  [SourceLayerParam.ImageSource]: 'url',
  [SourceLayerParam.VideoSource]: 'url',
  [SourceLayerParam.AudioSource]: 'url',
  [SourceLayerParam.HTMLContent]: 'html',
  [SourceLayerParam.Click]: 'clickUrl',
  [SourceLayerParam.Alt]: 'alt',
  [SourceLayerParam.Widget]: 'widget',
  [SourceLayerParam.FontSize]: '---',
  [SourceLayerParam.Condition]: '---',
  [SourceLayerParam.Font]: 'font',
  [SourceLayerParam.QR]: 'qr',
  [SourceLayerParam.Subtitles]: 'subtitle',
};

function setMappingParam(
  mappingObj: DPLayerMapping,
  param: SourceLayerParam,
  value: string,
  productIndex: number = null,
): DPLayerMapping {
  const propToUpdate = mappingPropsBySourceLayerParam[param];
  const {params} = layerByType[mappingObj.layerType];
  let updatedMapping = mappingObj;

  if (!value) {
    return {
      ...updatedMapping,
      [propToUpdate]: null,
    };
  }

  if (!!mappingObj.subtitle && param !== SourceLayerParam.Subtitles) {
    updatedMapping = {
      ...updatedMapping,
      subtitle: null,
    };
  }

  if (param === SourceLayerParam.Subtitles) {
    return {
      ...updatedMapping,
      ..._fromPairs(params.map((layer) => [mappingPropsBySourceLayerParam[layer], null])),
      [propToUpdate]: {
        paramKey: value,
        index: productIndex ?? 0,
      },
    };
  }

  if (
    (param === SourceLayerParam.QR && mappingObj.url) ||
    (param === SourceLayerParam.ImageSource && mappingObj.qr)
  ) {
    const nullableProp = param === SourceLayerParam.QR ? 'url' : 'qr';

    return {
      ...updatedMapping,
      [nullableProp]: null,
      [propToUpdate]: {
        paramKey: value,
        index: productIndex ?? 0,
      },
    };
  }

  if (propToUpdate !== 'txtData') {
    return {
      ...updatedMapping,
      [propToUpdate]: {
        paramKey: value,
        index: productIndex ?? 0,
      },
    };
  }

  return {
    ...updatedMapping,
    txtData: {
      ...updatedMapping.txtData,
      parts: [
        {
          blShift: null,
          isStatic: false,
          newLine: false,
          size: null,
          val: {
            paramKey: value,
            index: productIndex ?? 0,
          },
        },
      ],
    },
  };
}

export default setMappingParam;
